<template>
	<Overlay
		ref="overlay"
		class="overlay--deleteClassic"
		:root="true"
		:title="customText ? customText.title : `${titleItemType} verwijderen`"
		@close="onClose"
	>
		<template #body>
			<slot name="body">
				<span v-if="customText">
					{{ customText.body }}
				</span>
				<span v-else>
					Weet je zeker dat je deze {{ itemType }} definitief wil verwijderen?
					Dit kan nadien niet ongedaan gemaakt worden.
				</span>
			</slot>
		</template>
		<template #footer>
			<div class="footer-actions-group">
				<button
					class="button button--big button--no-padding button--light button--carnation"
					@click="onClose"
				>
					Annuleren
				</button>
				<button
					class="button button--big button--filled"
					:class="isLoading ? 'button--loading' : ''"
					@click="onDelete"
				>
					Verwijderen
					<span v-if="isLoading" class="loading" />
				</button>
			</div>
		</template>
	</Overlay>
</template>

<script src="./DeleteOverlay.js"></script>
